<template lang='pug'>
  bf-flex#onboarding.view.centered.container(v-show='account.id')
    article.container
      .slider.container
        #slide0.slide(v-show='page == 0')
          .logo.popup
            img( src='@/assets/popup.png' )
          main
            bf-divider.section.borderless
            p.centered-text
              | {{ $t("Click on [Add to Home Screen] button to add ") }}
              | {{ $t("BlueFaucet to your Home Screen") }}
            bf-divider.section.borderless
            a(@click="page++").button
              bf-button.large.tall
                template( v-slot:text )
                  h5 {{ $t('NEXT') }}

        #slide1.slide(v-show='page == 1')
          bf-divider.borderless.card
          .logo
            img( src='@/assets/onboarding1.png' )
          bf-divider.borderless.card
          main
            .image.container
              bf-flex.centered.text-overlay.column
                h2 {{ $t("BlueFaucet is your Local Marketplace") }}
                bf-divider.card.borderless
                p {{$t("You can buy and/or sell services and products with our easy to use online booking feature and tools")}}
            
            a(@click="page++").button
              bf-button.large.tall
                template( v-slot:text )
                  h5 {{ $t('NEXT') }}

        #slide2.slide(v-show='page == 2')
          bf-divider.borderless.card
          .logo
            img( src='@/assets/onboarding2.png' )
          bf-divider.borderless.card
          main
            .image.container
              bf-flex.centered.text-overlay.column
                h2 {{ $t("BlueFaucet makes you a happy customer") }}
                bf-divider.card.borderless
                p {{$t("We provide easy to use tools to find a service or product and arrange times to meet with the seller")}}
                  
            a(@click="page++").button
              bf-button.large.tall
                template( v-slot:text )
                  h5 {{ $t('NEXT') }}

        #slide3.slide(v-show='page == 3')
          bf-divider.borderless.card
          .logo
            img( src='@/assets/onboarding3.png' )
          bf-divider.borderless.card
          main
            .image.container
              bf-flex.centered.text-overlay.column
                h2 {{ $t("BlueFaucet helps you grow as a business") }}
                bf-divider.card.borderless
                p {{$t("We provide many tools to help you grow your business. You are able to list your services/products, and manage all your appointments and transactions with our smart calendar")}}

            router-link( :to='{ name: "new-profile" }').button
              bf-button.large.tall
                template( v-slot:text )
                  h5 {{ $t("LET'S START!") }}
</template>

<script>
  import { View, Animatable } from '@/mixins/view'
  import BFButton from '@/components/bf-button'

  export default {
    name: 'onboarding.view',

    mixins: [ View, Animatable ],

    components: {
      BFButton
    },

    data() {
      return {
        page: 0,
        route: ''
      }
    },

    watch: {
      account(curr, prev) {
        if ( curr.id && curr.merchant ) this.$router.go(-1)
      }
    },

    created() {
      if ( !this.$device.ios ) this.page = 1
    },
  }

</script>

<style scoped lang='stylus'>
  @import url('https://fonts.googleapis.com/css?family=Roboto:900&display=swap')

  .button
    display block

  #onboarding
    background rgb( 144 144 144 )
    min-height 100vh
    min-width 100vw

  #slide0 p
    padding 0 46px
    
  article
    display flex
    flex-direction column
    margin 0 auto
    height 100vh
    width 100vw
    border-radius 13px
    padding 45px 0
    background white
    box-sizing border-box
    box-shadow var(--shadow-panel)
    color var(--clr-blue)
    font-weight 700
    .image
      position relative
      height 216px

    .text-overlay
      position absolute
      right 0
      padding 46px
      box-sizing border-box
      width 100%
      height 100%
      background rgba( 255 255 255 .75 )

      > h1, > h2, > h3
        max-width 360px
        font-family Roboto, sans-serif

    ::-webkit-scrollbar
      width 0px
      height 0px

    @media(min-width: 420px)
      max-width 420px
      height auto    //height to fixed height? or auto?

  .slider
    margin auto 0
    .slide
      width 100%
      flex-shrink 0
      text-align center
      background white
      display flex
      flex-direction column
      p
        font-size 1.1em

    .logo
      > img
        max-width 100%
        padding 0 25px
        box-sizing border-box
    .logo.popup
      > img
        max-width 100%
        height 400px
        box-sizing border-box
        @media(max-width: 320px)
          height 300px

    .bf-button
      margin-top 20px
</style>
